import { render, staticRenderFns } from "./ReviewConsultantBox.vue?vue&type=template&id=06728383&scoped=true&lang=html&"
import script from "./ReviewConsultantBox.vue?vue&type=script&lang=js&"
export * from "./ReviewConsultantBox.vue?vue&type=script&lang=js&"
import style0 from "./ReviewConsultantBox.vue?vue&type=style&index=0&id=06728383&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06728383",
  null
  
)

component.options.__file = "ReviewConsultantBox.vue"
export default component.exports